import { Stack, SxProps, Typography } from '@mui/material';
import { ReactNode } from 'react';

import {
  MiniTable,
  MiniTableRow,
} from '@/components/tables/MiniTable/MiniTable';

export interface EdgeLabelCardProps {
  title?: string;
  titleSx?: SxProps;
  description: string;
  rows?: MiniTableRow[];
  children?: ReactNode;
}

export const EdgeLabelCard = ({
  title,
  description,
  rows,
  children,
  titleSx,
}: EdgeLabelCardProps) => {
  return (
    <Stack gap={2}>
      <Stack gap={0.5}>
        {title && (
          <Typography variant="title-xs" sx={titleSx}>
            {title}
          </Typography>
        )}
        <Typography variant="body-xs">{description}</Typography>
      </Stack>
      {rows && <MiniTable rows={rows} variant="default" />}
      {children}
    </Stack>
  );
};
